export type ClassWithTeachers = {
  isActive?: boolean | null;
  teachers?: Array<{ teacherId?: unknown }> | null;
};

export type TeacherWithClasses = {
  classes?: unknown[] | null;
};

function addTeacherId(ids: Set<number>, teacherId: unknown) {
  const id = Number(teacherId);
  if (Number.isFinite(id) && id > 0) ids.add(id);
}

/**
 * Unique teachers assigned to at least one active class.
 * If class rows have no teacher lists, falls back to teachers who have
 * any classes on their own record.
 */
export function countTeachersWithAtLeastOneClass(
  classes: readonly ClassWithTeachers[],
  teachers: readonly TeacherWithClasses[] = [],
): number {
  const ids = new Set<number>();

  for (const classItem of classes) {
    if (classItem.isActive === false) continue;
    for (const teacher of classItem.teachers ?? []) {
      addTeacherId(ids, teacher.teacherId);
    }
  }

  if (ids.size > 0) return ids.size;

  return teachers.filter((teacher) => (teacher.classes?.length ?? 0) > 0)
    .length;
}

export function formatTeachersWithClassesDeltaLabel(
  count: number | undefined,
): string | undefined {
  if (count === undefined) return undefined;
  return `${count} with class${count === 1 ? "" : "es"}`;
}
